import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=1b09721c&scoped=true&"
import script from "./MenuBar.vue?vue&type=script&lang=js&"
export * from "./MenuBar.vue?vue&type=script&lang=js&"
import style0 from "./MenuBar.vue?vue&type=style&index=0&id=1b09721c&lang=less&scoped=true&"
import style1 from "./MenuBar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b09721c",
  null
  
)

export default component.exports